import { render, staticRenderFns } from "./NewsItemContent.vue?vue&type=template&id=02a1fd02&"
import script from "./NewsItemContent.vue?vue&type=script&lang=js&"
export * from "./NewsItemContent.vue?vue&type=script&lang=js&"
import style0 from "./NewsItemContent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a1fd02')) {
      api.createRecord('02a1fd02', component.options)
    } else {
      api.reload('02a1fd02', component.options)
    }
    module.hot.accept("./NewsItemContent.vue?vue&type=template&id=02a1fd02&", function () {
      api.rerender('02a1fd02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/NewsItemContent.vue"
export default component.exports